import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 24px 16px 12px 16px;
  background: #fff;

  display: flex;
  justify-content: space-between;
  gap: 12px;
`;

export const Title = styled.div`
  border: 1px solid rgba(255, 255, 255);
  background: #fff;
  margin-right: 20px;

  display: flex;
  padding: 4px 8px;
  align-items: center;
  flex-shrink: 0;

  font-feature-settings: 'clig' off, 'liga' off;
  font-size: 18px;
  font-weight: 500;
`;
